import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import type { UseFormReturn } from "react-hook-form";
import type { Company } from "@/types/auth";

interface CompanyBasicInfoProps {
  form: UseFormReturn<Company>;
  isSubmitting: boolean;
  apiError?: { detail?: { [key: string]: string[] } };
}

export function CompanyBasicInfo({ form, isSubmitting, apiError }: CompanyBasicInfoProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Company Name</FormLabel>
            <FormControl>
              <Input 
                {...field} 
                disabled={isSubmitting}
                className={apiError?.detail?.name ? "border-red-500" : ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="number_of_products"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Number of Products</FormLabel>
            <FormControl>
              <Input 
                type="number" 
                {...field} 
                onChange={(e) => field.onChange(Number(e.target.value))}
                disabled={isSubmitting}
                className={apiError?.detail?.number_of_products ? "border-red-500" : ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="size"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Company Size</FormLabel>
            <FormControl>
              <Input 
                type="number" 
                {...field}
                onChange={(e) => field.onChange(Number(e.target.value))}
                disabled={isSubmitting}
                className={apiError?.detail?.size ? "border-red-500" : ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}